module.exports = __webpack_public_path__ + "img/viajes-paso-3.141c89a9.png";